import React from 'react'
import { Eye, Star, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';


export default function Card_3({ video, channel }) {

    const navigate = useNavigate();


    function select() {
        console.log(video, channel)
        navigate("/video", { state: { video, channel } });
    }

    function convertToMinutes(numb) {
        const totalSeconds = Math.floor(numb * 0.0166667 * 60); // convert to seconds
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        // Add leading zeros
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    }


    return (
        <div className='row mb-3' >
            <div className='col-5' >

                <div style={{ position: 'relative' }} >
                    <img src={video.Thumbnail} className="card-img-top" alt="..." onClick={() => select()} />
                    <span className='time' style={{ position: 'absolute', bottom: '5px', right: '5px' }}>{convertToMinutes(video.Duration)}</span>
                </div>

            </div>
            <div className='col-7' >
                <div className='d-flex flex-column justify-content-between' style={{ height: '100%' }} >
                    <h5 className='text-light card-title' >{video.Title}</h5>
                    <div className='card-info d-flex flex-row justify-content-between align-items-center' >
                        <p className='text-light p-0 m-0' ><Eye size={15} color='white' /> {video.PlayCount}</p>
                        <p className='text-light p-0 m-0' ><Star size={15} fill='#d4a014d6' strokeWidth={0} /> {video.avrate}</p>
                    </div>
                </div>
            </div>

        </div>
    )
}
